import React from 'react';

function Field({ id, label, value, onChange, multiline, hint }) {
  return (
    <div className="col-12">
      <label className="form-label" htmlFor={id}>
        {label}
      </label>
      {multiline ? (
        <textarea
          id={id}
          className="form-control"
          rows={typeof multiline === 'number' ? multiline : 3}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <input id={id} className="form-control" value={value} onChange={(e) => onChange(e.target.value)} />
      )}
      {hint ? <div className="form-text">{hint}</div> : null}
    </div>
  );
}

function setAuth(form, setField, patch) {
  setField('auth_copy', { ...(form.auth_copy || {}), ...patch });
}

export default function AdminSiteAuthFields({ form, setField }) {
  const auth = form.auth_copy || {};
  const benefits = Array.isArray(auth.benefits) ? auth.benefits : ['', '', ''];

  const setBenefit = (index, value) => {
    const next = [...benefits];
    next[index] = value;
    setAuth(form, setField, { benefits: next });
  };

  return (
    <>
      <SettingsCard title="Sign-in page (aside)" subtitle="Left panel on desktop; benefits list on mobile.">
        <div className="row g-3">
          <Field
            id="auth-signin-title"
            label="Sign-in title"
            value={auth.signin_aside_title || ''}
            onChange={(v) => setAuth(form, setField, { signin_aside_title: v })}
          />
          <Field
            id="auth-signin-checkout-title"
            label="Sign-in title (checkout flow)"
            value={auth.signin_checkout_aside_title || ''}
            onChange={(v) => setAuth(form, setField, { signin_checkout_aside_title: v })}
          />
          <Field
            id="auth-register-title"
            label="Register title"
            value={auth.register_aside_title || ''}
            onChange={(v) => setAuth(form, setField, { register_aside_title: v })}
          />
          <Field
            id="auth-register-checkout-title"
            label="Register title (checkout flow)"
            value={auth.register_checkout_aside_title || ''}
            onChange={(v) => setAuth(form, setField, { register_checkout_aside_title: v })}
          />
          <Field
            id="auth-signin-text"
            label="Sign-in description"
            value={auth.signin_aside_text || ''}
            onChange={(v) => setAuth(form, setField, { signin_aside_text: v })}
            multiline={3}
          />
          <Field
            id="auth-register-text"
            label="Register description"
            value={auth.register_aside_text || ''}
            onChange={(v) => setAuth(form, setField, { register_aside_text: v })}
            multiline={3}
          />
          <Field
            id="auth-signin-checkout-sub"
            label="Checkout sign-in subtitle (card)"
            value={auth.signin_checkout_subtitle || ''}
            onChange={(v) => setAuth(form, setField, { signin_checkout_subtitle: v })}
            multiline={2}
          />
          {[0, 1, 2].map((i) => (
            <Field
              key={`benefit-${i}`}
              id={`auth-benefit-${i}`}
              label={`Benefit ${i + 1}`}
              value={benefits[i] || ''}
              onChange={(v) => setBenefit(i, v)}
            />
          ))}
          <Field
            id="auth-register-privacy"
            label="Register privacy note"
            value={auth.register_privacy_note || ''}
            onChange={(v) => setAuth(form, setField, { register_privacy_note: v })}
            multiline={2}
          />
          <Field
            id="auth-signin-prompt"
            label="“New customer?” prompt"
            value={auth.signin_new_prompt || ''}
            onChange={(v) => setAuth(form, setField, { signin_new_prompt: v })}
          />
        </div>
      </SettingsCard>

      <SettingsCard title="Forgot & reset password">
        <div className="row g-3">
          <Field
            id="auth-forgot-title"
            label="Forgot password — aside title"
            value={auth.forgot_aside_title || ''}
            onChange={(v) => setAuth(form, setField, { forgot_aside_title: v })}
          />
          <Field
            id="auth-forgot-text"
            label="Forgot password — aside text"
            value={auth.forgot_aside_text || ''}
            onChange={(v) => setAuth(form, setField, { forgot_aside_text: v })}
            multiline={2}
          />
          <Field
            id="auth-forgot-sub"
            label="Forgot password — card subtitle"
            value={auth.forgot_card_subtitle || ''}
            onChange={(v) => setAuth(form, setField, { forgot_card_subtitle: v })}
            multiline={2}
          />
          <Field
            id="auth-forgot-wa"
            label="WhatsApp prefill (forgot password)"
            value={auth.forgot_whatsapp_prefill || ''}
            onChange={(v) => setAuth(form, setField, { forgot_whatsapp_prefill: v })}
          />
          <Field
            id="auth-reset-title"
            label="Reset password — aside title"
            value={auth.reset_aside_title || ''}
            onChange={(v) => setAuth(form, setField, { reset_aside_title: v })}
          />
          <Field
            id="auth-reset-text"
            label="Reset password — aside text"
            value={auth.reset_aside_text || ''}
            onChange={(v) => setAuth(form, setField, { reset_aside_text: v })}
            multiline={2}
          />
          <Field
            id="auth-reset-invalid-title"
            label="Invalid link — aside title"
            value={auth.reset_invalid_aside_title || ''}
            onChange={(v) => setAuth(form, setField, { reset_invalid_aside_title: v })}
          />
          <Field
            id="auth-reset-invalid-text"
            label="Invalid link — aside text"
            value={auth.reset_invalid_aside_text || ''}
            onChange={(v) => setAuth(form, setField, { reset_invalid_aside_text: v })}
            multiline={2}
          />
          <Field
            id="auth-reset-invalid-body"
            label="Invalid link — card message"
            value={auth.reset_invalid_body || ''}
            onChange={(v) => setAuth(form, setField, { reset_invalid_body: v })}
            multiline={2}
          />
        </div>
      </SettingsCard>
    </>
  );
}

function SettingsCard({ title, subtitle, children }) {
  return (
    <div className="card border shadow-sm mb-3">
      <div className="card-header py-2">
        <h2 className="h6 mb-0">{title}</h2>
        {subtitle ? <p className="small text-muted mb-0 mt-1">{subtitle}</p> : null}
      </div>
      <div className="card-body">{children}</div>
    </div>
  );
}
